<template>
  <div class="upload-container" :style="{ width: '100%' }" v-loading="loading" element-loading-text="上传中...">
    <el-upload v-if="!value" drag action="" :style="{ width: '100%' }" :http-request="httpRequest" :limit="1"
      :show-file-list="false" :accept="accept">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        <em>点击</em> 或 拖拽文件上传
      </div>
      <div class="file-tip" v-if="accept">
        仅支持{{ accept }}格式
      </div>
    </el-upload>

    <div v-else class="file-preview">
      <div class="file-content">
        <div class="file-info">
          <i class="el-icon-document"></i>
          <span class="file-name">{{ fileName }}</span>
          <i class="delete-icon" @click="removeFile">✕</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    width: {
      type: String,
      default: "100%",
    },
    progressWidth: {
      type: Number,
      default: 100,
    },
    progressType: {
      type: String,
      default: "circle",
    },
    accept: {
      type: String,
      default: "",
    },
    isEncrypt: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      percentage: 0,
      showImageViewer: false,
      response: null,
      fileName: "",
      loading: false,
    };
  },
  computed: {},
  methods: {
    async httpRequest(options) {
      this.loading = true
      try {
        const res = await this.uploadFile(options, this.onUploadProgress, this.isEncrypt);
        this.fileName = options.file.name
        this.$emit('input', res);
        this.percentage = 0;
      } catch (error) {
        this.percentage = 0;
      }
      this.loading = false
    },
    async uploadFile(option, onUploadProgress) {
      const type = option.file.type //文件类型
      let formData = new FormData()
      formData.append("file", option.file)
      let url = '/analyzer/admin/modules/fileupload/uploadfile'

      const res = await this.$request.post(
        url,
        formData,
        { headers: { "Content-Type": "multipart/form-data" }, onUploadProgress }
      )
      if (res.data && res.data.code === 200) {
        option.onSuccess(res.data.data)
        return res.data.data
      } else {
        option.onError()
        return
      }
    },
    onUploadProgress(e) {
      if (e && e.total) {
        this.percentage = Math.max(0, Math.min(99, Math.floor((e.loaded / e.total) * 100)))
      }
    },
    removeFile() {
      this.$emit('input', '');
    }
  },
};
</script>

<style scoped>
.upload-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.file-preview {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  min-height: 180px;
  box-sizing: border-box;
  width: 100%;
}

.file-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: auto;
  max-width: 100%;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.file-info .el-icon {
  font-size: 24px;
  color: #409eff;
  flex-shrink: 0;
}

.file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #606266;
  max-width: calc(100% - 30px);
}

.delete-icon {
  font-size: 12px;
  color: #606266;
  cursor: pointer;
  margin-left: 5px;
  font-style: normal !important;
  line-height: 1;
  font-family: sans-serif;
}

/* 文件格式提示样式 */
.file-tip {
  color: #909399;
  font-size: 12px;
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 10px;
  left: 0;
}
</style>